<div id="agencia-confirmado">
    <div class="modal-content ">
      <div class="modal-header d-block mt-5 border-0 text-center">
        <img *ngIf="check===1" src="assets/images/body/reserva-ok.svg" class="mt-5" alt="">
        <img *ngIf="check===0" src="assets/images/body/reserva-ok.svg" class="mt-5" alt="" style="visibility: hidden;">
        <h3 class="modal-title text-secondary text-center m-auto" id="loginLabel" style="color: #0099ff;">{{titulo}}</h3>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
        <i class="bi-x modal-close" aria-label="Close" (click)="salir()"></i>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10 text-center z-index--top" style="padding-bottom: 50px;">
            <p class="mb-5">{{texto}}</p>
            <a  class="btn btn-lg btn-primary btn-reservar rounded-pill" (click)="salir()" >{{etiqueta}}</a>
          </div>
          <div class="col-1"></div>

        </div>
      </div>
      <div class="modal-footer mb-4 border-0 bg-foot" style="left: 335px; width: 250px; height: 230px;">
       <!--<img src="/assets/images/body/register-pending-1.svg" class="left" alt="">  -->
      </div>
    </div>
  </div>
